import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.anchor.js";
var render = function render() {
  var _vm$listTerms$find$na, _vm$listTerms$find, _vm$groupedItemsByDep, _vm$itemsRequiringTas;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "container-centered small text-left"
  }, [_vm.order.items.length == 0 ? _c("div", [_c("h3", {
    staticClass: "text-center"
  }, [_vm._v("Your cart is empty")])]) : _vm.order.items.length > 0 ? _c("div", {
    staticClass: "order-maincontent"
  }, [_c("div", {
    staticClass: "order-maincontent-data"
  }, [_c("h3", [_vm._v("Order Information")]), _c("div", {
    staticClass: "order-maincontent-data-address"
  }, [!_vm.sameAddress ? _c("div", {
    staticStyle: {
      "grid-column": "2 / 2"
    }
  }, [_c(VCheckbox, {
    staticStyle: {
      "margin-bottom": "-1rem !important"
    },
    attrs: {
      id: "sameAddress",
      label: "Billing address is identical",
      readonly: !_vm.isEditingAddresses
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    },
    model: {
      value: _vm.sameAddress,
      callback: function callback($$v) {
        _vm.sameAddress = $$v;
      },
      expression: "sameAddress"
    }
  })], 1) : _vm._e(), _c("div", [_vm._m(0), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c("adress", {
    ref: "deliveryAddress",
    attrs: {
      baseModel: _vm.order.delivery_address,
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      readOnly: !_vm.isEditingAddresses,
      disabledCountry: true,
      disabledState: true,
      countryTooltipMessage: "You cannot change the country of delivery at this stage because some of the wines in your cart should be only available for this country.",
      stateTooltipMessage: "If you want to be delivered in an other state, please contact our customer service."
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    }
  })], 1)]), _c("div", [_vm._m(1), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_vm.sameAddress == false ? _c("adress", {
    ref: "billingAddress",
    attrs: {
      baseModel: _vm.order.billing_address,
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      readOnly: !_vm.isEditingAddresses
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    }
  }) : _vm._e(), _vm.sameAddress ? _c("div", [_c(VCheckbox, {
    attrs: {
      id: "sameAddress",
      label: "Billing address is identical",
      readonly: !_vm.isEditingAddresses
    },
    on: {
      change: function change($event) {
        return _vm.addressChange();
      }
    },
    model: {
      value: _vm.sameAddress,
      callback: function callback($$v) {
        _vm.sameAddress = $$v;
      },
      expression: "sameAddress"
    }
  })], 1) : _vm._e()], 1)]), _c("div", {
    staticClass: "order-maincontent-data-address-btn-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small order-maincontent-data-address-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        _vm.isEditingAddresses ? _vm.cancelAddresses() : _vm.editAddresses();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditingAddresses ? "Cancel" : "Edit addresses") + " ")]), _vm.isEditingAddresses ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small order-maincontent-data-address-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: _vm.saveAddress
    }
  }, [_vm._v(" Save ")]) : _vm._e()], 1)]), _vm.deliveryAddressFaultedMessage ? _c("div", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.deliveryAddressFaultedMessage) + " ")]) : _vm._e(), _c("div", {
    staticClass: "delivery-instructions"
  }, [_c("div", [_vm._m(2), _vm.isInboundAvailable ? _c("div", {
    staticClass: "mb-2"
  }, [_c(VCheckbox, {
    attrs: {
      label: "Request to be stored inbound",
      "hide-details": "auto"
    },
    model: {
      value: _vm.order.stockTransferIsAskedByUser,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "stockTransferIsAskedByUser", $$v);
      },
      expression: "order.stockTransferIsAskedByUser"
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [!_vm.editingDeliveryInstructions ? [_c("div", {
    staticClass: "flex --baseline"
  }, [_c("div", {
    staticClass: "text-smaller",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.order.delivery_instructions) || "No instruction")
    }
  }), _c(VIcon, {
    staticClass: "fa fa-pen text-sm ml-2 icon-link",
    on: {
      click: _vm.startEditDeliveryInstructions
    }
  })], 1)] : [_c(VTextarea, {
    ref: "inputDeliveryInstruction",
    staticClass: "delivery-instructions-textarea",
    attrs: {
      rows: "3",
      filled: "",
      placeholder: "Write our instructions here",
      "hide-details": "auto"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) return null;
        $event.preventDefault();
        return _vm.updateDeliveryInstructions.apply(null, arguments);
      }
    },
    model: {
      value: _vm.order.delivery_instructions,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "delivery_instructions", $$v);
      },
      expression: "order.delivery_instructions"
    }
  }), _c(VCheckbox, {
    attrs: {
      label: "Save for next purchases"
    },
    model: {
      value: _vm.isSetDeliveryAddressAsDefaultForUserAddress,
      callback: function callback($$v) {
        _vm.isSetDeliveryAddressAsDefaultForUserAddress = $$v;
      },
      expression: "isSetDeliveryAddressAsDefaultForUserAddress"
    }
  }), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.updateDeliveryInstructions
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-arrow-right",
    staticStyle: {
      "margin-right": "0.25rem"
    },
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save delivery instructions ")], 1)]], 2)]), _vm.canChangeCurrency ? _c("div", [_vm._m(3), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [!_vm.editingOrderCurrency ? [_c(VTooltip, {
    attrs: {
      top: ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c("div", _vm._g(_vm._b({
          staticClass: "cursor--pointer",
          domProps: {
            innerHTML: _vm._s(String.nl2br(_vm.listCurrencies.find(function (x) {
              return x.id === _vm.order.currency;
            }).name))
          },
          on: {
            click: _vm.startEditOrderCurrency
          }
        }, "div", attrs, false), on))];
      }
    }], null, false, 856650524)
  }, [_c("span", [_vm._v("Click to change the currency")])])] : [_c(VAutocomplete, {
    ref: "inputOrderCurrency",
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.listDefaultCurrencies,
      disabled: _vm.isUpdatingOrderCurrency,
      "item-value": "id",
      "item-text": "name",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto"
    },
    on: {
      change: _vm.updateOrderCurrency,
      blur: function blur() {
        if (_vm.initialCurrency === _vm.order.currency) {
          _vm.editingOrderCurrency = false;
        }
      }
    },
    model: {
      value: _vm.order.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "currency", $$v);
      },
      expression: "order.currency"
    }
  })]], 2)]) : _vm._e()]), _vm.loggedUserData.userGroup != "USER" ? _c("div", {
    staticClass: "order-maincontent-data-paymentterms"
  }, [_c("div", [_vm._m(4), _c("div", [_c("div", {
    staticClass: "text-smaller"
  }, [_vm._v(" " + _vm._s((_vm$listTerms$find$na = (_vm$listTerms$find = _vm.listTerms.find(function (x) {
    return x.id === _vm.order.buyer_term;
  })) === null || _vm$listTerms$find === void 0 ? void 0 : _vm$listTerms$find.name) !== null && _vm$listTerms$find$na !== void 0 ? _vm$listTerms$find$na : "Undefined") + " ")])])])]) : _vm._e(), _vm.getOrderTotalIncludeCreditNoteCurrency() > 0 ? _c("div", {
    staticClass: "--one-column"
  }, [_c("div", {
    staticClass: "order-maincontent-data-total"
  }, [_c("div", [_vm._v(" Total : " + _vm._s(_vm.formatPrice(_vm.getOrderTotalIncludeCreditNoteCurrency())) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " * ")]), !_vm.orderHasMultipleDepartures ? _c("div", {
    staticClass: "text-tax-info"
  }, [_vm.groupedItemsByDeparture[0].expeditionMethod === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", [_vm._v(_vm._s(" duties & taxes free"))])] : _vm.isConcernedByVat ? [_vm.isOrderForIndividualUs ? [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])] : [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])]] : [_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]], 2) : _vm._e()]), _vm._m(5)]) : _vm._e()]), _c("div", {
    staticClass: "order-maincontent-summary",
    class: [_vm.isFetchingShippingCosts && "--disabled"],
    attrs: {
      id: "order-summary"
    }
  }, [_c("h3", [_vm._v("Order Summary")]), _vm.isFetchingShippingCosts && !((_vm$groupedItemsByDep = _vm.groupedItemsByDeparture) !== null && _vm$groupedItemsByDep !== void 0 && _vm$groupedItemsByDep.length) ? _vm._l(3, function (i) {
    return _c("div", {
      key: i
    }, [_c(VSkeletonLoader, {
      staticClass: "my-1",
      attrs: {
        width: "100%",
        type: "list-item-avatar-three-line"
      }
    })], 1);
  }) : _vm._l(_vm.groupedItemsByDeparture, function (groupedItems, ii) {
    var _vm$getAnyShippingMet, _vm$order, _vm$order2, _vm$order$expedition_;
    return _c("div", {
      key: ii,
      attrs: {
        id: "order-summary-".concat(ii)
      }
    }, [_c("h4", {
      staticClass: "my-2",
      attrs: {
        id: "items_" + ((_vm$getAnyShippingMet = _vm.getAnyShippingMethod(groupedItems)) === null || _vm$getAnyShippingMet === void 0 ? void 0 : _vm$getAnyShippingMet.id)
      }
    }, [_vm._v(" From "), _c("strong", [_vm._v(" " + _vm._s(_vm.getAnyShippingMethod(groupedItems).departureCountry) + " " + _vm._s(_vm.getAnyShippingMethod(groupedItems).version > 1 ? _vm.getAnyShippingMethod(groupedItems).version : "") + " ")])]), _c("div", {
      staticClass: "order-maincontent-summary-items mt-4"
    }, [_vm._l(groupedItems, function (item) {
      var _item$wine, _item$wine2;
      return _c("div", {
        key: item.id_item,
        staticClass: "item-row",
        class: [!_vm.isActiveItem(item) && "disabled-like", _vm.isCollapsed && "collapse"]
      }, [_c("div", {
        staticClass: "item-row-img"
      }, [!_vm.imagesBroken.includes(item.id_item) && (_item$wine = item.wine) !== null && _item$wine !== void 0 && _item$wine.imageThumbnail ? _c("img", {
        attrs: {
          src: item.wine.imageThumbnail,
          alt: ""
        },
        on: {
          error: function error($event) {
            return _vm.imagesBroken.push(item.id_item);
          }
        }
      }) : !_vm.imagesBroken.includes(item.id_item) && (_item$wine2 = item.wine) !== null && _item$wine2 !== void 0 && _item$wine2.image ? _c("img", {
        attrs: {
          src: item.wine.image,
          alt: ""
        },
        on: {
          error: function error($event) {
            return _vm.imagesBroken.push(item.id_item);
          }
        }
      }) : _c("img", {
        attrs: {
          src: require("@/assets/images/_temp/wine_default_primary_img.png"),
          alt: ""
        }
      })]), _c("div", {
        staticClass: "item-row-informations"
      }, [_c("div", {
        staticClass: "item-row-winename"
      }, [_c("router-link", {
        staticClass: "router-link",
        attrs: {
          to: _vm.productDetails(item.wine)
        }
      }, [_c("wine-naming", {
        key: "wine-naming-".concat(item.wine.id_wine),
        attrs: {
          wineNamingData: item.wine.naming_data,
          isPrefixWinery: true,
          isSuffixBottling: true,
          isSuffixType: true
        }
      })], 1)], 1), _c("div", {
        staticClass: "item-row-lineprices"
      }, [_c("WineDiscountTooltip", {
        staticClass: "wine-discount",
        attrs: {
          wine: item.wine,
          currency: _vm.order.currency
        }
      }), _c("div", {
        staticClass: "item-row-quantity"
      }, [_c("div", [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Qty")]), _vm.isProcessingPayment ? _c("div", {
        staticClass: "item-row-lineprices-maindata"
      }, [_vm._v(" " + _vm._s(item.quantity / item.casingId.match(/\d+/)[0]) + " ")]) : _c("div", [_c(VTextField, {
        key: _vm.quantityToggleKey,
        staticClass: "ma-0 pa-0 text-center",
        attrs: {
          type: "number",
          value: item.quantity / item.casingId.match(/\d+/)[0],
          min: 1,
          disabled: !_vm.isActiveItem(item) || _vm.isProcessingPayment
        },
        on: {
          change: function change($event) {
            return _vm.changeQuantityOrder(item, $event, groupedItems);
          },
          keypress: _vm.filterIntegerKey
        }
      })], 1)])]), _c("div", {
        staticClass: "item-row-conditionment"
      }, [_c("div", [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Casing")]), _vm.isProcessingPayment ? _c("div", {
        staticClass: "item-row-lineprices-maindata"
      }, [_vm._v(" " + _vm._s(_vm.casingWines.find(function (x) {
        return x.value == item.casingId;
      }).textCard) + " ")]) : _c("div", [_c(VSelect, {
        staticClass: "v-text-field-no-label",
        attrs: {
          items: _vm.casingsAvailable(item),
          disabled: !_vm.isActiveItem(item) || _vm.isProcessingPayment,
          "item-value": "casingId",
          "item-text": "textCard",
          "hide-details": "auto"
        },
        on: {
          change: function change($event) {
            return _vm.changeQuantityOrder(item, 1, groupedItems);
          }
        },
        model: {
          value: item.casingId,
          callback: function callback($$v) {
            _vm.$set(item, "casingId", $$v);
          },
          expression: "item.casingId"
        }
      })], 1)])]), _c("div", {
        staticClass: "item-row-unitprice"
      }, [_c("div", [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Case price")]), _c("div", {
        staticClass: "item-row-lineprices-maindata text-nowrap"
      }, [_vm._v(" " + _vm._s("".concat(_vm.formatPrice(_vm.getUnitPriceCurrencyForItem(item, groupedItems) * item.casingId.match(/\d+/)[0]), " ").concat(_vm.getSymbolCurrency(_vm.order.currency))) + " ")]), item.casingId !== "OC1" && item.casingId !== "OWC1" ? _c("div", {
        staticClass: "text-tax-info text-no-transform"
      }, [_vm._v(" " + _vm._s("".concat(_vm.formatPrice(_vm.getUnitPriceCurrencyForItem(item, groupedItems)), " ").concat(_vm.getSymbolCurrency(_vm.order.currency))) + " / bottle ")]) : _vm._e()])]), _c("div", {
        staticClass: "item-row-totalprice"
      }, [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Total")]), _c("div", {
        staticClass: "item-row-lineprices-maindata text-nowrap"
      }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.getUnitPriceCurrencyForItem(item, groupedItems) * item.quantity)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")]), _c("div", {
        staticClass: "text-tax-info"
      }, [item.expeditionMethod === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", [_vm._v(_vm._s(" duties & taxes free"))])] : _vm.isConcernedByVat ? [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])] : [_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]], 2)]), !_vm.isProcessingPayment ? _c("div", {
        staticClass: "item-row-remove"
      }, [_c("a", {
        staticClass: "far fa-trash-alt text-decoration-none",
        attrs: {
          title: "Remove"
        },
        on: {
          click: function click($event) {
            return _vm.deleteItem(item.id_item);
          }
        }
      })]) : _vm._e()], 1), !_vm.isActiveItem(item) && _vm.order.status < _vm.orderStatus.find(function (x) {
        return x.id == "AWAITING_VALIDATION";
      }).status ? _c("div", {
        staticClass: "errorLabel"
      }, [_vm._v(" This product is no longer available. Please remove it. ")]) : _vm._e()])]);
    }), groupedItems.length > 4 ? _c("div", {
      staticClass: "items-collapsis"
    }, [_vm.isCollapsed ? _c("div", {
      staticClass: "overlay"
    }) : _vm._e(), _vm.isCollapsed ? _c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "info",
        text: ""
      }
    }, [_vm._v(" " + _vm._s("Click below to show the ".concat(groupedItems.length - 4, " other reference").concat(groupedItems.length - 4 > 1 ? "s" : "", " of this order")) + " ")]) : _vm._e(), _c(VBtn, {
      on: {
        click: function click($event) {
          return _vm.collapse(ii);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        dark: ""
      }
    }, [_vm._v(_vm._s(_vm.isCollapsed ? "mdi-chevron-down" : "mdi-chevron-up"))])], 1)], 1) : _vm._e(), _c("div", {
      staticClass: "order-maincontent-data-shippingmethod-edit --one-column"
    }, [_vm._m(6, true), _c("div", [_vm.expedition_methods.length === 0 || _vm.isFetchingShippingCosts ? _c(VSkeletonLoader, {
      attrs: {
        width: "100%",
        type: "heading"
      }
    }) : [_vm.isShippingInErrorEvenSuperAdmin(groupedItems) ? [_c("div", {
      staticClass: "flex"
    }, [_c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "red",
        text: ""
      }
    }, [_vm._v(" There is no shipping method available. Please contact our "), _c("router-link", {
      staticClass: "router-link",
      attrs: {
        to: {
          name: "userContact"
        }
      }
    }, [_vm._v(" Customer Services. ")])], 1)], 1)] : _vm.isShippingOutOfRange(groupedItems) ? [_c("div", {
      staticClass: "flex"
    }, [_c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_vm._v(" " + _vm._s(_vm.getShippingOutOfRangeMessage(groupedItems)) + " ")])], 1)] : _c(VBtnToggle, {
      staticClass: "btn-group",
      attrs: {
        tile: "",
        group: "",
        mandatory: _vm.getAnyGroupedItem(groupedItems).shippingMethods.length === 1,
        items: _vm.expedition_methods
      },
      model: {
        value: _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId],
        callback: function callback($$v) {
          _vm.$set(_vm.order.expedition_methods, _vm.getAnyShippingMethod(groupedItems).departureWarehouseId, $$v);
        },
        expression: "\n                        order.expedition_methods[\n                          getAnyShippingMethod(groupedItems).departureWarehouseId\n                        ]\n                      "
      }
    }, _vm._l(_vm.getAnyGroupedItem(groupedItems).shippingMethods, function (shipItem) {
      return _c(VBtn, {
        key: shipItem.id,
        staticClass: "btn-group-btn btn-ship-choice",
        attrs: {
          value: shipItem,
          disabled: _vm.isProcessingPayment || _vm.order.stockTransferIsAskedByUser && shipItem.id === _vm.expeditionMethods.CELLAR_STORAGE.id
        },
        on: {
          click: function click($event) {
            return _vm.changeExpeditionMethod(shipItem, groupedItems);
          }
        }
      }, [_c("div", [_c("div", [_c("i", {
        class: "fas ".concat(shipItem.icon)
      }), _vm._v(" " + _vm._s(shipItem.label) + " ")]), shipItem.id === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", {
        staticClass: "btn-ship-choice-important-data"
      }, [_vm._v(" " + _vm._s(_vm.order.stockTransferIsAskedByUser ? "Incompatible with inbound process" : "Manage the pickup on my own") + " ")]), _c("div", {
        staticClass: "btn-ship-choice-important-data"
      }, [_vm._v("Shipping & tax free")])] : [_c("div", {
        staticClass: "btn-ship-choice-important-data"
      }, [_vm._v(" ETA : " + _vm._s(shipItem.eta_label) + " ")]), _c("div", {
        staticClass: "btn-ship-choice-important-data",
        domProps: {
          innerHTML: _vm._s(_vm.showShippingPriceMinusDefault(shipItem, groupedItems))
        }
      })]], 2)]);
    }), 1), _vm.errorLabels.shipping[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId] ? _c("div", {
      staticClass: "errorLabel"
    }, [_vm._v(" " + _vm._s(_vm.errorLabels.shipping[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId]) + " ")]) : _vm._e(), !_vm.isShippingInError(groupedItems) && (_vm$order = _vm.order) !== null && _vm$order !== void 0 && _vm$order.expedition_methods && _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId] && _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId].id !== _vm.expeditionMethods.CELLAR_STORAGE.id ? _c("div", {
      staticClass: "eta text-left"
    }, [_vm.shouldShowWarningDefaultShipping(groupedItems) ? _c("div", {
      staticClass: "mb-1"
    }, [_vm._v(" To qualify for free shipping fee, please increase your order to 120 regular bottles or a total of 90 liters. ")]) : _vm._e(), _c("div", [_vm._v(" Estimated time of arrival, from warehouse departure : "), _c("strong", [_vm._v(" " + _vm._s(_vm.getEtaLabel(_vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId].eta_min_hours, _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId].eta_max_hours)) + " ")])])]) : _vm._e()]], 2), (_vm$order2 = _vm.order) !== null && _vm$order2 !== void 0 && _vm$order2.expedition_methods && ((_vm$order$expedition_ = _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId]) === null || _vm$order$expedition_ === void 0 ? void 0 : _vm$order$expedition_.id) === _vm.expeditionMethods.CELLAR_STORAGE.id ? _c("div", {
      staticClass: "mt-3"
    }, [_vm._m(7, true), _c("StorageTermsReference")], 1) : _vm._e()])], 2), _c("div", {
      staticClass: "order-maincontent-summary-linetotal"
    }, [_vm.orderHasMultipleDepartures ? _c("div", {
      staticClass: "order-maincontent-summary-linetotal-total mt-2"
    }, [_c("div", [_vm._v(" Subtotal : " + _vm._s("".concat(_vm.formatPrice(_vm.getSubtotalPriceForDeparture(groupedItems)), " ").concat(_vm.getSymbolCurrency(_vm.order.currency))) + " * ")]), _c("div", {
      staticClass: "text-tax-info"
    }, [_vm.getAnyGroupedItem(groupedItems).expeditionMethod === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", [_vm._v(_vm._s(" duties & taxes free"))])] : _vm.isConcernedByVat ? [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])] : [_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]], 2)]) : _vm._e()])]);
  }), _vm.getOrderTotalIncludeCreditNoteCurrency() > 0 ? _c("div", {
    staticClass: "--one-column"
  }, [_c(VDivider, {
    staticClass: "my-5"
  }), _c("div", {
    staticClass: "order-maincontent-data-total"
  }, [_c("div", [_vm._v(" Total : " + _vm._s(_vm.formatPrice(_vm.getOrderTotalIncludeCreditNoteCurrency())) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " * ")]), !_vm.orderHasMultipleDepartures ? _c("div", {
    staticClass: "text-tax-info"
  }, [_vm.order.expedition_method === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", [_vm._v(_vm._s(" duties & taxes free"))])] : _vm.isConcernedByVat ? [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])] : [_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]], 2) : _vm._e()]), _vm._m(8)], 1) : _vm._e()], 2)]) : _vm._e()]), !_vm.dialogAdjustment.isLoading ? _c("div", {
    staticClass: "order-bottom-content container-centered small"
  }, [_c("div", {
    staticClass: "order-bottom-content-incoterms"
  }, [_vm._m(9), _c("textarea", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.dialogAdjustment.message,
      expression: "dialogAdjustment.message"
    }],
    staticClass: "w100p",
    staticStyle: {
      "font-size": "0.75em !important"
    },
    attrs: {
      "hide-details": "auto",
      disabled: _vm.dialogAdjustment.isLoading,
      placeholder: _vm.dialogAdjustment.message_placeholder
    },
    domProps: {
      value: _vm.dialogAdjustment.message
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.dialogAdjustment, "message", $event.target.value);
      }
    }
  })])]) : _vm._e(), _c("div", {
    staticClass: "order-bottom-content container-centered small"
  }, [_vm.order.items.length != 0 ? _c("div", {
    staticClass: "order-bottom-content-incoterms"
  }, [_vm._m(10)]) : _vm._e(), _vm.order.items.length > 0 ? _c("div", {
    staticClass: "order-bottom-content-acceptterms"
  }, [_c("WholesalersData", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  }), _c(VCheckbox, {
    attrs: {
      "data-cy": "order-basket-agree-brand-checkbox"
    },
    model: {
      value: _vm.checkboxCGV,
      callback: function callback($$v) {
        _vm.checkboxCGV = $$v;
      },
      expression: "checkboxCGV"
    }
  }, [_c("div", {
    staticClass: "order-bottom-content-acceptterms-label",
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" I agree with the " + _vm._s(_vm.$whitelabel.brand) + " " + _vm._s(" ") + " "), _c("a", {
    on: {
      click: function click($event) {
        return _vm.openToS();
      }
    }
  }, [_vm._v("terms of sales")]), _vm._v(" . ")])]), _c("div", {
    staticClass: "order-bottom-content-acceptterms-certifylaw"
  }, [_c(VCheckbox, {
    attrs: {
      "data-cy": "order-basket-agree-laws-checkbox"
    },
    model: {
      value: _vm.checkboxLawCompliance,
      callback: function callback($$v) {
        _vm.checkboxLawCompliance = $$v;
      },
      expression: "checkboxLawCompliance"
    }
  }, [_c("div", {
    staticClass: "order-bottom-content-acceptterms-certifylaw-label",
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" I certify that I am aware of the laws governing my place of residence and that I am complying with them. ")])])], 1), ((_vm$itemsRequiringTas = _vm.itemsRequiringTastingPhoto) === null || _vm$itemsRequiringTas === void 0 ? void 0 : _vm$itemsRequiringTas.length) > 0 ? _c("div", {
    staticClass: "order-bottom-content-acceptterms-tastingPhoto-container"
  }, _vm._l(_vm.itemsRequiringTastingPhoto, function (itemRequiring) {
    return _c("div", {
      key: "tastingPhoto-chkbox-" + itemRequiring.id_item,
      staticClass: "order-bottom-content-acceptterms-tastingPhoto"
    }, [_c(VCheckbox, {
      model: {
        value: _vm.checkboxTastingPhoto[itemRequiring.id_item],
        callback: function callback($$v) {
          _vm.$set(_vm.checkboxTastingPhoto, itemRequiring.id_item, $$v);
        },
        expression: "checkboxTastingPhoto[itemRequiring.id_item]"
      }
    }, [_c("div", {
      staticClass: "order-bottom-content-acceptterms-tastingPhoto-label",
      attrs: {
        slot: "label"
      },
      slot: "label"
    }, [_vm._v(" I commit to taking a photo of each bottle of «" + _vm._s(_vm.wineNaming(_vm.$whitelabel, itemRequiring.wine.naming_data, true, true, true)) + "» at the time of its tasting. ")])])], 1);
  }), 0) : _vm._e(), _vm.errorLabels.cgv.length > 0 ? _c("div", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.cgv) + " ")]) : _vm._e(), _vm.errorLabels.tastingPhoto.length > 0 ? _c("div", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.tastingPhoto) + " ")]) : _vm._e(), !!Object.values(_vm.errorLabels.shipping).length ? _c("div", {
    staticClass: "errorLabel"
  }, [_vm._v(" A shipping type is missing on some items ")]) : _vm._e()], 1) : _vm._e()]), _vm.order.items.length > 0 ? _c("div", {
    staticClass: "button-end-page-container"
  }, [_c("div", [_vm.errorLabels.quantity_orders.length > 0 ? _c("p", {
    staticClass: "errorLabel text-center text-underline pointer",
    on: {
      click: function click($event) {
        return _vm.scrollTo("#items_" + _vm.errorLabels.quantity_orders[0].anchor);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.quantity_orders[0].text) + " ")]) : _vm._e(), _c("div", [_vm.IS_STRIPE_ENABLED && !_vm.isImporterPreventPayment && !_vm.isAllowedOrderWithoutPayment() ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.mustRecalculateCharges,
      rounded: true,
      loading: _vm.isProcessingPayment,
      "data-cy": "order-basket-continue-to-payment-btn"
    },
    on: {
      click: function click($event) {
        return _vm.continueToPayment();
      }
    }
  }, [_vm._v(" Continue to payment ")]) : _vm._e(), !_vm.IS_STRIPE_ENABLED || _vm.isAllowedOrderWithoutPayment() || _vm.isImporterPreventPayment ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.mustRecalculateCharges,
      rounded: true,
      loading: _vm.updatingOrderStatus
    },
    on: {
      click: function click($event) {
        return _vm.userValidateOrderWithoutPayment();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isImporterPreventPayment ? "Order now" : "Order without set payment") + " ")]) : _vm._e()], 1)])]) : _vm._e(), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-map-marked"
  }), _vm._v(" Delivery address ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-map-marked-alt"
  }), _vm._v(" Billing address ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-truck-loading"
  }), _vm._v(" Delivery instructions ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-coins"
  }), _vm._v(" Currency ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "far fa-clock"
  }), _vm._v(" Payment terms ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "order-maincontent-summary-extrainformations"
  }, [_c("div", [_c("i", {
    staticClass: "fas fa-shield-alt"
  }), _vm._v(" 100% secure payments ")]), _c("div", [_c("i", {
    staticClass: "fas fa-check-circle"
  }), _vm._v(" Guaranteed origin products ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-truck"
  }), _vm._v(" Shipping type ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("span", {
    staticClass: "free-storage-text"
  }, [_vm._v("Free storage for 3 months.")]), _c("br"), _vm._v(" A notification asking to collect the goods will be sent every month "), _c("strong", [_vm._v("for 2 months")]), _vm._v(" , then every week "), _c("strong", [_vm._v("for the last month.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "order-maincontent-summary-extrainformations"
  }, [_c("div", [_c("i", {
    staticClass: "fas fa-shield-alt"
  }), _vm._v(" 100% secure payments ")]), _c("div", [_c("i", {
    staticClass: "fas fa-check-circle"
  }), _vm._v(" Guaranteed origin products ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-comment"
  }), _vm._v(" Comment ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "text-incoterms"
  }, [_vm._v(" *Sold in delivered duty paid incoterm only if you have not selected stored in the cellar. Delivered duty paid is a delivery agreement whereby the seller assumes all of the responsibility, risk, and costs associated with transporting goods until the buyer receives or transfers them at the destination port. This agreement includes paying for shipping costs, export and import duties, insurance, and any other expenses incurred during shipping to an agreed-upon location in the buyer's country. ")]), _c("div", {
    staticClass: "text-incoterms"
  }, [_vm._v("All items are subject to availability.")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };